import * as _ from "lodash";
import * as angular from "angular";

let UserCardListComponent = {
    templateUrl: "/angular/components/user/user-card-list.component.html",
    selector: "vcUserCardList",
    restrict: "E",
    replace: true,
    bindings: {
        selectedUser: "=?",
        provider: "=?",
    },

    controller: class UserCardListController {
        // * bindings for typescript compiler *
        public selectedUser?: any;
        public provider?: any;
        // ************************************

        private modelsUtils: any;

        constructor(ModelsUtils: any) {
            this.modelsUtils = ModelsUtils;
        }

        selectUser(user: any): void {
            this.selectedUser = this.modelsUtils.user(_.cloneDeep(user));
        }
    },
};

angular
    .module("user")
    .component(UserCardListComponent.selector, UserCardListComponent);
